import styled from 'styled-components';

export const ButtonContainer = styled.footer`
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Container = styled.section`
  width: 256px;
`;

export const Content = styled.main`
  padding: 8px 12px;
`;

export const Header = styled.header`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h1 {
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
`;

export const Separator = styled.hr`
  border-bottom-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.disabledColor};
  margin: 4px 0;
`;
